import { useNavigate } from "react-router-dom";
import './HomePage.css';

function HomePage() {
    let navigate = useNavigate();

    function handleGoToApp() {
        navigate('/app');
    }

    return (
        <div className="HomePage">
            <h1 className='darkheader'>Polony AI</h1>
            <p className="blogtext">
                <a href="https://nicholasbrooking.com/2024/01/15/LLM-to-agent">Check out the Blog Post</a>
                <p>Choose an example and press send to get a demonstration of how it solves a problem. Compare the output with the base LLM model GPT-3.5 which Polony is built from.</p>
            </p>
            <button onClick={handleGoToApp}>Go to app</button>
        </div>
    )
}

export default HomePage;